import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { TokenSchema } from '../schema';
import { TokenType } from '../schema/types';
import { TokenUrl } from './TokenUrl';

const getTokens = () =>
  apiClient
    .get<TokenType[]>(expand(TokenUrl.TOKENS, {}))
    .then((response) => TokenSchema.array().parse(response.data));

export const useTokensQuery = createApiQueryHook(['tokens'], getTokens);
